import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';

interface Token {
  token: string;
  status: number;
  error: string;
}

interface Authorize {
  email: string;
  error: string;
  id: string;
  name: string;
  organization: string;
  organizationName: string;
  status: number;
}

@Injectable({
  providedIn: 'root'
})
export class CallbackService {
  private readonly url: string = environment.url_onboarding;
  private readonly redirectUri: string = environment.redirect_uri;

  constructor(private http: HttpClient) {}

  /**
   * Takes callback code and returns a token
   * @param code a token that Identity pass via a callback URL
   * @returns an object with a valid token
   */
  getToken(code: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        redirectURI: this.redirectUri,
        code: code
      }),
      withCredentials: true
    };

    return this.http.get<Token>(`${this.url}/authorize/code`, httpOptions);
  }

  /**
   * Takes the token and returns user infos and organization id
   * @param token a valid token
   * @returns an object with user infos and organization id
   */
  getAuthorization(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      }),
      withCredentials: true
    };

    return this.http.get<Authorize>(`${this.url}/authorize`, httpOptions);
  }
}
